import moment from "moment";
import BuildingModel from '../model/building';

export const renderBuildingAddress = (rowData) => {
    if (!rowData.building) {
        return '';
    }

    const {
        building: { street, house_number, city, postalcode },
    } = rowData;

    return BuildingModel.fullAddress(street, house_number, city, postalcode);
};

export const renderTimeFromLastSending = (date) => {
    return date ? moment(date).fromNow() : date; //'Never',
};